import { storeRef } from "@/components/providers/StoreProvider"
import { TourState } from "@/lib/redux/features/tour/types"

export const getTourPrice = (inputTour: TourState['inputTour']) => {
  const tourState: any = storeRef.current?.getState().tour
  const tour = tourState?.tour_details?.data
  const departureSchedule = tour?.departureSchedule?.find((d: any) => d.id === inputTour.selectedDepartureSchedule)
  return {
    totalAmount: (inputTour.inputAdt * (departureSchedule?.prices[0]?.priceAdt)) + 
      (inputTour.inputChd1 * (departureSchedule?.prices[0]?.priceChd1)) + 
      (inputTour.inputChd2 * (departureSchedule?.prices[0]?.priceChd2)) + 
      (inputTour.inputInf * (departureSchedule?.prices[0]?.priceInf))
  }
}